var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"d-flex align-center justify-center icon-wrapper",attrs:{"href":_vm.officialLineUrl,"target":"_blank"}},[_c('div',{staticClass:"icon"},[_vm._v("?")])])}
var staticRenderFns = []

export { render, staticRenderFns }